import PropTypes from 'prop-types'
import React, { useEffect, useReducer } from 'react'
import { useTranslation } from 'react-i18next'

import PredictionBox from '../../Shared/PredictionBox'

import { initStateObject, objectReducer } from '../../../reducers/default'
import { fetchEventBenchmark } from '../../../api/events'
import ErrorMessage from '../../Shared/ErrorMessage'
import LoaderSkeleton from '../../Shared/LoaderSkeleton'

/**
 * Two benchmark Prediction boxes on event page under header.
 * @Tags( event, api )
 * @Endpoints( /events/[eid]/benchmark )
 * @ApiLogic( ../../api/events )
 */
export default function EventBenchmarks({ eventId, showPercentage, hideError = false, onErrorChange, showBencmark = true }) {
  const { t } = useTranslation()
  const [benchmark, dispatch] = useReducer(objectReducer, initStateObject)

  useEffect(() => {
    fetchEventBenchmark(dispatch, eventId, showPercentage)
  }, [eventId, showPercentage])

  useEffect(() => {
    onErrorChange?.(benchmark.error)
  }, [benchmark.error, onErrorChange])

  return (
    <>
      {!hideError && benchmark.error && (
        <div>
          <ErrorMessage classNames="mb-0" danger>{t('common.errors.commonError')}</ErrorMessage>
        </div>
      )}

      {benchmark.loading && (
        <LoaderSkeleton />
      )}

      <div className={`row events-benchmarks gap-3 ${benchmark.success ? '' : 'd-none'}`}>
        {benchmark.content.today && (
          <div className="events-benchmarks__item col">
            <PredictionBox
              main={{
                title: t('Event.benchmarks.now.left'),
                number: showBencmark ? benchmark.content.today.value : null,
              }}
              second={{
                title: t('Event.benchmarks.now.right'),
                number: showBencmark ? benchmark.content.today.benchmark : null,
              }}
              type="now"
              showPercentage={showPercentage}
            />
          </div>
        )}
        {benchmark.content.prediction && (
          <div className="events-benchmarks__item col">
            <PredictionBox
              main={{
                title: t('Event.benchmarks.prediction.left'),
                number: showBencmark ? benchmark.content.prediction.value : null,
              }}
              second={{
                title: t('Event.benchmarks.prediction.right'),
                number: showBencmark ? benchmark.content.prediction.benchmark : null,
              }}
              type="prediction"
              showPercentage={showPercentage}
            />
          </div>
        )}
      </div>

      {benchmark.success && (
        <p className="events-benchmarks__note">{t('Event.benchmarks.excludesFreeTickets')}</p>
      )}
    </>
  )
}

EventBenchmarks.propTypes = {
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showPercentage: PropTypes.bool,
  hideError: PropTypes.bool,
  onErrorChange: PropTypes.func,
}
